export default "__VITE_ASSET__0d0003e9__"